var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClick = function SvgClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0065FF",
    fillRule: "evenodd",
    d: "M26.611 13.407c0 5.16-8.184 13.406-13.305 13.406S0 18.566 0 13.407 8.185 0 13.306 0 26.61 8.247 26.61 13.407m-7.983 0c0 2.063-3.274 5.362-5.322 5.362s-5.323-3.298-5.323-5.362 3.274-5.363 5.323-5.363c2.048 0 5.322 3.299 5.322 5.363",
    clipRule: "evenodd"
  })));
};
export default SvgClick;